import { styled } from '@mui/material/styles';
import { Paper, Button, Box } from '@mui/material';
import { GlobalStyles } from '@mui/material';

// Global styles
export const SamlGlobalStyles = () => (
  <GlobalStyles
    styles={(theme) => ({
      body: {
        backgroundColor: theme.palette.common.white,
      },
    })}
  />
);

// Styled components approach
export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3, 2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '50%',
}));

export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
  marginTop: theme.spacing(1),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
  marginTop: '100px',
  textTransform: 'none',
}));

export const BrandImage = styled('img')(({ theme }) => ({
  margin: theme.spacing(1),
  width: '13rem',
}));

export const FooterContainer = styled(Box)({
  bottom: '10px',
});

export const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
}));

// For backward compatibility with the makeStyles approach
const useStyles = () => ({
  paper: {
    padding: '24px 16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '50%',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '8px',
  },
  submit: {
    margin: '24px 0 16px',
    marginTop: '100px',
    textTransform: 'none',
  },
  brand: {
    margin: '8px',
    width: '13rem',
  },
  footer: {
    bottom: '10px',
  },
  modalStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: '#fff',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
    padding: '16px 32px 24px',
  },
});

export default useStyles;